import { gql } from '@apollo/client';
import { ASSESSMENT_IMPLEMENTATIONS } from 'graph/fragments/assessment';
import { CHECKLIST_IMPLEMENTATIONS } from 'graph/fragments/checklist';

const GET_CURRICULUM_ASSESSMENTS = gql`
  ${ASSESSMENT_IMPLEMENTATIONS}
  ${CHECKLIST_IMPLEMENTATIONS}

  query getCurriculumAssessments(
    $assessmentWhere: AssessmentsWhereInput
    $checklistWhere: ChecklistsWhereInput
  ) {
    assessments(where: $assessmentWhere) {
      ...AssessmentImplementations
      educatorPacket {
        id
        title
        resources {
          id
          title
          url
        }
      }
    }
    checklists(where: $checklistWhere) {
      ...ChecklistImplementations
    }
  }
`;

export default GET_CURRICULUM_ASSESSMENTS;
